export const getTransactionToken = () => {
  return document.querySelector('body').getAttribute('data-id');
};
